import axios from "axios";

// Reuse the default axios baseURL set in main.jsx (window.ReactAppData.restUrl + doc/v1/).
// Exporting a dedicated instance lets us add interceptors without polluting the global axios.
const client = axios.create({
    baseURL: `${window.ReactAppData?.restUrl ?? ""}doc/v1/`,
    headers: { "Content-Type": "application/json" },
});

// Attach WP REST nonce if available (some WP setups require this for POST)
if (typeof window !== "undefined" && window.wpApiSettings?.nonce) {
    client.defaults.headers["X-WP-Nonce"] = window.wpApiSettings.nonce;
}

export default client;
